import Autocomplete from "@trevoreyre/autocomplete-js";
import { isFunction } from "common/utils/helpers/is";
import { track } from "jiffy-analytics";

export default class AddressAutocomplete {
  constructor(selector, baseClass = "autocomplete", options = {}) {
    this.apiKey = window?.jiffy?.smartyEmbeddedApiKey;
    this.inputLengthThreshold = 4;
    this.maxResults = 10;

    this.onSearch = this.onSearch.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.submitCallback = null;
    this.inputController = new Autocomplete(selector, {
      search: this.onSearch,
      renderResult: (result, props) => this.renderItem(result, props),
      getResultValue: result => this.getResultValue(result),
      onSubmit: result => this.onSubmit(result),
      debounceTime: 500,
      baseClass,
      ...options
    });
  }

  // eslint-disable-next-line class-methods-use-this
  async onSearch(input) {
    if (!this.apiKey || input.length < this.inputLengthThreshold) {
      return [];
    }

    track("auto_complete_search", {
      query: input,
      page: window.location.href
    });

    const url = `https://us-autocomplete-pro.api.smarty.com/lookup?key=${
      this.apiKey
    }&search=${encodeURI(input)}&max_results=${this.maxResults}`;
    try {
      const request = await fetch(url);
      const response = await request.json();
      if (response.suggestions) {
        return response.suggestions;
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Error getting Smarty response", e.message);
    }
    return [];
  }

  onSubmit(result) {
    isFunction(this.submitCallback) && this.submitCallback(result);
  }

  onSubmitCallback(callback) {
    this.submitCallback = callback;
    return this;
  }

  // eslint-disable-next-line class-methods-use-this
  getResultValue(result) {
    return result.street_line;
  }

  // eslint-disable-next-line class-methods-use-this
  renderItem(result, props) {
    return `
      <li ${props}>
        <span>${result.street_line}, <span class="full-address">${result.city}, ${result.state} ${result.zipcode}</span></span>
      </li>
    `;
  }

  destroy() {
    this.inputController.destroy();
  }
}
